import Chip from '@components/Chip';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { Fragment, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DeleteIcon from './DeleteIcon';
import useContact from './hooks/useContact';

function Receiver() {
    const [to, setTo] = useState('other');
    const { state, setState } = useContext(GiftOrderContext);
    const { giftRecipients } = state;
    const { t } = useTranslation('gift');
    const { openContacts } = useContact((name, phoneNo) => {
        setState((prevState) => ({
            ...prevState,
            giftRecipients: [...prevState.giftRecipients, { name, phoneNo }],
        }
        ));
    });
    const deleteContact = (index: number) => {
        setState((prev) => ({
            ...prev,
            giftRecipients: prev.giftRecipients.filter((_, i) => i !== index),
        }));
    };
    return (
        <Column fullWidth spacing={6}>
            <Column spacing={22}>
                <Text color={colors.gray7} fontWeight='bold' size='2xl'>
                    {t('giftOrder.receiverTitle')}
                </Text>
                <Chip.Container variant='fill'>
                    <Chip isSelected={to === 'me'}
                        onClick={() => setTo('me')}>
                        {t('giftOrder.giftToMe')}
                    </Chip>
                    <Chip isSelected={to === 'other'}
                        onClick={() => {
                            setTo('other');
                            openContacts();
                        }}>
                        {t('giftOrder.addFromContacts')}
                    </Chip>
                </Chip.Container>
            </Column>
            {giftRecipients.map((contact, i) => (
                <Fragment key={`contact${i}`}>
                    <Row fullWidth justify='flex-end' >
                        <Row spacing={4} onClick={() => deleteContact(i)}>
                            <DeleteIcon/>
                            <DeleteText color={colors.gray5} fontWeight='bold' >
                                {t('giftOrder.delete')}
                            </DeleteText>
                        </Row>
                    </Row>
                    <Column spacing={20} fullWidth>
                        <TextField placeholder={t('giftOrder.recipientNamePlaceholder')}
                            readOnly
                            name='recipientName'
                            value={contact.name}/>
                        <TextField placeholder={t('giftOrder.recipientPhonePlaceholder')}
                            readOnly
                            name='recipientPhone'
                            value={contact.phoneNo}/>
                    </Column>
                </Fragment>
            ))}
        </Column>
    );
}

const DeleteText = styled(Text)`
    text-decoration: underline;
    text-underline-offset: 3px;
`;

export default Receiver;
